if (!customElements.get('soera-stories')) {
  customElements.define('soera-stories', class extends HTMLElement {
    connectedCallback() {
      this.stopVideo();
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.cards = [...this.querySelectorAll('[data-story-card]')];
      this.filters = [...this.querySelectorAll('[data-filter]')];
      this.more = this.querySelector('[data-load-more]');
      this.category = 'all';
      this.limit = 16;
      this.filters.forEach(button => button.addEventListener('click', () => {
        this.stopVideo();
        this.category = button.dataset.filter;
        this.limit = 16;
        this.updateCards();
      }, options));
      this.more.addEventListener('click', () => {
        this.limit += 6;
        this.updateCards();
      }, options);
      this.querySelectorAll('[data-open-video]').forEach(trigger => trigger.addEventListener('click', event => {
        event.preventDefault();
        this.openVideo(trigger);
      }, options));
      this.querySelector('[data-toolbar]').hidden = this.cards.length === 0;
      this.updateCards();
    }
    updateCards() {
      const matches = this.cards.filter(card => this.category === 'all' || card.dataset.category === this.category);
      this.cards.forEach(card => { card.hidden = !matches.includes(card) || matches.indexOf(card) >= this.limit; });
      this.filters.forEach(button => {
        const active = button.dataset.filter === this.category;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
      });
      this.more.hidden = matches.length <= this.limit;
      this.querySelector('[data-video-count]').textContent = matches.length === 1 ? this.dataset.countSingular : this.dataset.countLabel.replace('[count]', matches.length);
    }
    openVideo(trigger) {
      const id = trigger.dataset.videoId;
      if (!/^[a-zA-Z0-9_-]{11}$/.test(id)) return;
      document.querySelectorAll('soera-stories').forEach(other => other.stopVideo());
      const media = trigger.closest('.soera-stories__media');
      const iframe = document.createElement('iframe');
      iframe.src = `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&playsinline=1&rel=0`;
      iframe.title = trigger.dataset.videoTitle;
      iframe.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
      iframe.allowFullscreen = true;
      iframe.referrerPolicy = 'strict-origin-when-cross-origin';
      this.trigger = trigger;
      this.iframe = iframe;
      trigger.hidden = true;
      media.append(iframe);
      iframe.focus();
    }
    stopVideo() {
      this.iframe?.remove();
      if (this.trigger) this.trigger.hidden = false;
      this.iframe = null;
      this.trigger = null;
    }
    disconnectedCallback() {
      this.stopVideo();
      this.controller?.abort();
    }
  });
}
